// extracted by mini-css-extract-plugin
export default {"fullWidth":"Qo-z","image":"Ro-z","lazyLoadPicture":"So-z","lazyLoadSpinner":"To-z","lazyLoadSpin":"Uo-z","lazyLoadImage":"Vo-z","hasStyledAspectRatio":"Wo-z"};